import script from "./EighthIhramPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EighthIhramPage.vue?vue&type=script&setup=true&lang=js"

import "./EighthIhramPage.vue?vue&type=style&index=0&id=4a0301d7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a0301d7"]])

export default __exports__